import { getCookie } from "./cookies";
import { incrementLoaderCount, decrementLoaderCount } from "./axios";
import {
  LEGACY_MEMBER_LOGIN_URL,
  LEGACY_MEMBER_URL,
  LEGACY_STAFF_LOGIN_URL,
} from "../Enums/LegacyRedirection";

const loadHiddenLegacyIframe = (loginUrl: string, token: string): Promise<void> => {
  return new Promise<void>((resolve) => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.style.width = "0";
    iframe.style.height = "0";

    iframe.onload = () => resolve();
    iframe.onerror = () => resolve();

    const url = new URL(loginUrl);
    url.searchParams.append("token", token);
    iframe.src = url.toString();
    document.body.appendChild(iframe);
  });
};

export const generateLegacyCookies = async (): Promise<void> => {
  try {
    const token = getCookie("token");
    if (!token) {
      return;
    }

    await Promise.all([
      loadHiddenLegacyIframe(LEGACY_MEMBER_LOGIN_URL, token),
      loadHiddenLegacyIframe(LEGACY_STAFF_LOGIN_URL, token),
    ]);
  } catch (error) {
    console.error("[generateLegacyCookies] Error:", error);
  }
};

export const initializeLegacySessions = async (
  iframeLoadingRef?: React.MutableRefObject<boolean>,
  removeDelay: number = 0
): Promise<void> => {
  const callId = Math.random().toString(36).substr(2, 6);

  try {
    const token = getCookie("token");
    if (!token) {
      return;
    }

    if (iframeLoadingRef?.current) {
      return;
    }

    if (iframeLoadingRef) {
      iframeLoadingRef.current = true;
    }

    incrementLoaderCount();

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.position = "absolute";
    iframe.style.opacity = "0";
    iframe.style.pointerEvents = "none";

    const legacyUrl = new URL(`${LEGACY_MEMBER_URL}/init_session.asp`);
    legacyUrl.searchParams.append("token", token);
    legacyUrl.searchParams.append("hide-navigation", "true");
    iframe.src = legacyUrl.toString();

    let loadTimer: NodeJS.Timeout | null = null;
    let iframeLoaded = false;

    const cleanupAndDecrementLoader = () => {
      if (iframeLoaded) {
        return;
      }

      iframeLoaded = true;

      if (iframeLoadingRef) {
        iframeLoadingRef.current = false;
      }
      decrementLoaderCount();
    };

    iframe.onload = () => {
      loadTimer = setTimeout(() => {
        if (iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
        cleanupAndDecrementLoader();
      }, removeDelay);
    };

    iframe.onerror = () => {
      console.error(`[initSessions-${callId}] Error loading iframe`);
      if (loadTimer) {
        clearTimeout(loadTimer);
      }
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
      cleanupAndDecrementLoader();
    };

    document.body.appendChild(iframe);
  } catch (error) {
    console.error(`[initSessions-${callId}] ERROR:`, error);
    if (iframeLoadingRef) {
      iframeLoadingRef.current = false;
    }
    decrementLoaderCount();
  }
};
